import { Form, Input } from "antd";

import avatar from "assets/images/default.webp";
import { Certifications } from "./Certifications";
import {
  useGetTalentProfile,
} from "features/settings/hooks/useGetTalentProfile";
import { useState } from "react";
import ProfileSidebar from "./TalentProfileSidebar";

const DEFAULT_COVER = "/assets/cover_image.png";

export const TalentCertifications = () => {
  const { data, isLoading: isGetTPLoading } = useGetTalentProfile();
  const [form] = Form.useForm();
  const [resizedBlob, setResizedBlob] = useState<Blob | null>(null);
  const [coverPhotoBlob, setCoverPhotoBlob] = useState<Blob | null>(null);
  const [active, setActive] = useState("Certifications");



  return (
    <>
      <Form form={form} disabled={isGetTPLoading}>
        <div className="flex justify-between mb-4">
          <div>
            <h4 className="font-semibold text-lg text-primary">
              Personal info
            </h4>
            <h3 className="text-sm">Update your details here.</h3>
          </div>
        </div>
        <hr />
        <div className="grid grid-cols-1 md:grid-cols-5 my-3 md:my-5 gap-3">
          <Form.Item noStyle name="image">
            <Input type="hidden" />
          </Form.Item>

          <div className="relative col-span-5">
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              id="fileInput"
            />
            <img
              src={
                coverPhotoBlob
                  ? URL.createObjectURL(coverPhotoBlob)
                  : data?.data.user.cover_photo || DEFAULT_COVER
              }
              alt="cover"
              className="w-full h-full object-cover"
            />

            <div className="absolute -bottom-6 left-4">
              <div className="relative w-fit">

                <img
                  src={
                    resizedBlob
                      ? URL.createObjectURL(resizedBlob)
                      : data?.data.dp ?? avatar
                  }
                  alt="avatar"
                  className="h-20 w-20 rounded-full border-2 border-white shadow-lg"
                />

                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  id="cover_photo"
                />

              </div>
            </div>

            <h3 className="font-medium mt-10"></h3>
            <h3 className="text-xs"></h3>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
          <ProfileSidebar active={active} onSelect={setActive} />

          <div className="md:col-span-5 p-4 rounded shadow-lg w-full">
            <Certifications isLoading={isGetTPLoading} data={data ? data?.data.certifications : []} />
            <br />
            <hr />
          </div></div>
      </Form>
    </>
  );
};
